import { useDashboardsStore } from "@follaw-fr/stores/dashboards";
import { useUserStore } from "@follaw-fr/stores/user";
import {
  trimFiltersByFeatures,
  trimFilterValue,
  type FiltersByFeature,
} from "@follaw-fr/utils/filter.utils";
import { isEqual } from "lodash";
import { storeToRefs } from "pinia";
import { computed, toRaw } from "vue";
import { useFeaturesFilters } from "./useFeaturesFilters";

// Filter change detection
export function useFilterChangeDetection() {
  const { selectedDashboard } = storeToRefs(useDashboardsStore());
  const { sharedFilters } = storeToRefs(useUserStore());
  const { activeFiltersByFeature } = useFeaturesFilters();

  /** Extract and Format Dashboard filters and local filters  */
  const dashboardThematics = computed(() => ({
    thematics: selectedDashboard.value
      ? trimFilterValue(selectedDashboard.value.filters?.thematic_ids)
      : [],
    subThematics: selectedDashboard
      ? trimFilterValue(selectedDashboard.value?.filters?.subthematic_ids)
      : [],
  }));

  const localThematics = computed(() => ({
    thematics: trimFilterValue(sharedFilters.value.selected_thematics),
    subThematics: trimFilterValue(sharedFilters.value.selected_subthematics),
  }));

  const localFilters = computed(() =>
    trimFiltersByFeatures(
      toRaw(activeFiltersByFeature.value) as FiltersByFeature
    )
  );
  const dashboardFilters = computed(() => {
    if (!selectedDashboard.value) return undefined;
    return trimFiltersByFeatures(
      selectedDashboard.value.filters as FiltersByFeature
    );
  });

  /** Compare dashboard local filters and additional query to infer filterChanged  */
  const filterChanged = computed(() => {
    return (
      !isEqual(
        selectedDashboard.value?.filters?.search ?? "", // change null to empty string for the comparison
        sharedFilters.value.selected_keyword
      ) ||
      !isEqual(dashboardFilters.value, localFilters.value) ||
      !isEqual(dashboardThematics.value, localThematics.value)
    );
  });
  return {
    filterChanged,
  };
}
